import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { HIGHLIGHT } from '~pricing/components/Summary/useStyles';

import { MD_MEDIA_QUERY } from '~shared/media-query';

type Props = {
  packageName: string;
};
type Rules = 'Highlighted' | 'Package';

export default createUseStyles<Rules, Props, PricingAppTheme>(
  ({ spacing, type, pricingPalette, packageTheme }: PricingAppTheme) => ({
    Package: {
      position: 'relative',
      border: `1px solid ${pricingPalette.colors.pebble}`,
      [MD_MEDIA_QUERY]: {
        '&:not(:last-of-type):not($Highlighted)': {
          borderRight: 'none',
        },
      },
      '& aside': {
        top: 0,
        right: 0,
        width: '100%',
        '&:before, &:after': {
          display: 'none',
        },
        '& p': {
          transform: 'none',
          top: 0,
          left: 0,
          width: '100%',
          fontSize: 13,
        },
      },
      '& header': {
        paddingTop: spacing[6],
      },
    },
    Highlighted: {
      ...HIGHLIGHT(pricingPalette.colors.flint, packageTheme),
      borderWidth: '3px !important',
      '& header': {
        paddingTop: spacing[6] - 3,
      },
    },
  })
);
